export const enUSLists = {
  title: 'Lists',
  loading: 'Loading lists…',
  noCollections: 'No lists yet',
  noCollectionsHint: 'Create your first list to start adding items.',
  newList: 'New list',
  createDialogTitle: 'New list',
  nameLabel: 'List name',
  namePlaceholder: 'e.g. Groceries',
  create: 'Create',
  cancel: 'Cancel',
  validationNameRequired: 'Name is required',
  quickAddPlaceholder: 'Add an item…',
  quickAddNoSuggestions: 'No suggestions',
  quickAddCreate: 'Add "{{title}}"',
  add: 'Add',
  noItems: 'No items yet — add one above.',
  loadError: 'Failed to load lists',
  toastCollectionCreated: 'List created',
  toastCollectionCreatedError: 'Failed to create list',
  toastItemAdded: 'Item added',
  toastItemAddedError: 'Failed to add item',
  toastItemReopened: 'Item reopened',
  toastItemAlreadyOnList: 'Already on the list',
  toastItemDuplicateTitle: 'An item with this name is already on the list',
  pasteDialogTitle: 'Add multiple items',
  pasteDialogDescription: 'Review the items before adding them to your list.',
  pasteItemPlaceholder: 'Item',
  pasteRemoveRow: 'Remove item',
  pasteConfirm: 'Add {{total}} items',
  toastPasteAdded: '{{total}} items added',
  toastPastePartial: '{{added}} added, {{failed}} failed',
  toastPasteError: 'Failed to add items',
  toastItemToggledError: 'Failed to update item',
  clearCompleted: 'Clear completed',
  refresh: 'Refresh',
  listUpdated: 'List updated',
  undo: 'Undo',
  toastCleared: 'Completed items cleared',
  toastClearError: 'Failed to clear completed items',
  toastRestored: 'Items restored',
  toastRestoreError: 'Failed to restore items',
  toastReorderError: 'Failed to reorder items',
  dragHandleLabel: 'Drag to reorder',
  picture: 'Picture',
  pictureAdd: 'Add picture',
  pictureView: 'View picture',
  pictureReplace: 'Replace',
  pictureRemove: 'Remove',
  picturePreviewTitle: 'Item picture',
  picturePreviewLoading: 'Loading picture…',
  picturePreviewError: 'Could not load picture',
  pictureOpenInDrive: 'Open in Drive',
  pictureClose: 'Close',
  pictureUploadSuccess: 'Picture updated',
  pictureUploadError: 'Failed to upload picture',
  pictureRemoveSuccess: 'Picture removed',
  pictureRemoveError: 'Failed to remove picture',
  pictureInvalidType: 'Please choose an image (JPEG, PNG, GIF, or WebP)',
  // List kind (create dialog)
  kindLabel: 'List type',
  kindGeneric: 'Generic',
  kindGroceries: 'Groceries',
  kindGroceriesHint: 'Seeds default supermarket-area categories.',
  // Categories
  uncategorized: 'Other',
  manageCategories: 'Categories',
  manageCategoriesTitle: 'Manage categories',
  addCategory: 'Add category',
  categoryNamePlaceholder: 'e.g. Bakery',
  categoryNameRequired: 'Category name is required',
  noCategories: 'No categories yet. Add one to group your items.',
  renameCategory: 'Rename',
  deleteCategory: 'Delete category',
  moveCategoryUp: 'Move up',
  moveCategoryDown: 'Move down',
  saveCategory: 'Save',
  close: 'Close',
  assignCategory: 'Category',
  assignToCategory: 'Assign to category',
  removeFromCategory: 'Remove from category',
  toastCategoryCreated: 'Category added',
  toastCategoryCreatedError: 'Failed to add category',
  toastCategoryRenamed: 'Category renamed',
  toastCategoryRenamedError: 'Failed to rename category',
  toastCategoryDeleted: 'Category deleted',
  toastCategoryDeletedError: 'Failed to delete category',
  toastCategoryReorderError: 'Failed to reorder categories',
  toastItemCategorized: 'Item moved',
  toastItemCategorizedError: 'Failed to move item',
  // Item detail sheet (#364)
  detailSheetTitle: 'Item details',
  detailClose: 'Close',
  detailRenameLabel: 'Name',
  detailRenamePlaceholder: 'Item name',
  detailCategoryLabel: 'Category',
  detailCategoryNone: 'No category',
  detailDueDateLabel: 'Due date',
  detailDueDateClear: 'Clear due date',
  detailAssigneeLabel: 'Assignee',
  detailAssigneeNone: 'Unassigned',
  detailImageLabel: 'Picture',
  detailDelete: 'Delete item',
  detailsButtonLabel: 'Item details',
  toastItemRenamed: 'Item renamed',
  toastItemRenamedError: 'Failed to rename item',
  toastItemUpdated: 'Item updated',
  toastItemUpdatedError: 'Failed to update item',
  toastItemDeleted: 'Item deleted',
  toastItemDeletedError: 'Failed to delete item',
  // List-actions overflow menu (#364 PR3)
  listActions: 'List actions',
  pasteItems: 'Paste items',
  renameList: 'Rename list',
  deleteList: 'Delete list',
  renameListTitle: 'Rename list',
  save: 'Save',
  toastListRenamed: 'List renamed',
  toastListRenamedError: 'Failed to rename list',
  deleteListConfirmTitle: 'Delete this list?',
  deleteListConfirmDescription:
    'This permanently removes the list and all of its items. This cannot be undone.',
  deleteListConfirmAction: 'Delete',
  toastListDeleted: 'List deleted',
  toastListDeletedError: 'Failed to delete list',
} as const;
